import { USER_STORAGE_KEY } from '@shared/auth/auth-route';
import { hasImpersonationClaim, tokenStore } from '@shared/auth/token.store';

const TOKEN_KEY = 'impersonation-token';
const TENANT_KEY = 'impersonation-tenant-name';
const TOKEN_PARAM = 'impersonationToken';
const TTL_PARAM = 'impersonationTTL';
const TENANT_PARAM = 'tenantName';

interface SavedToken {
  token: string;
  expireAt: number;
}

function readSavedToken(): SavedToken | null {
  try {
    const saved = JSON.parse(
      sessionStorage.getItem(TOKEN_KEY) ?? 'null',
    ) as Partial<SavedToken> | null;
    return typeof saved?.token === 'string' && typeof saved.expireAt === 'number'
      ? { token: saved.token, expireAt: saved.expireAt }
      : null;
  } catch {
    return null;
  }
}

function restoreImpersonation(): boolean {
  const saved = readSavedToken();
  if (saved && hasImpersonationClaim(saved.token)) {
    tokenStore.setState({ accessToken: saved });
    return true;
  }
  clearImpersonation();
  return false;
}

export function applyImpersonationFromUrl(): boolean {
  const url = new URL(window.location.href);
  const token = url.searchParams.get(TOKEN_PARAM);
  if (!token) return restoreImpersonation();

  const tenantName = url.searchParams.get(TENANT_PARAM);
  url.searchParams.delete(TOKEN_PARAM);
  url.searchParams.delete(TTL_PARAM);
  url.searchParams.delete(TENANT_PARAM);
  window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);

  if (!hasImpersonationClaim(token)) return restoreImpersonation();

  clearImpersonation();
  tokenStore.getState().setAccessToken(token);
  if (tenantName) sessionStorage.setItem(TENANT_KEY, tenantName);
  return true;
}

export function confirmImpersonation(): void {
  const stored = tokenStore.getState().accessToken;
  if (stored && hasImpersonationClaim(stored.token)) {
    sessionStorage.setItem(TOKEN_KEY, JSON.stringify(stored));
  }
}

export function getImpersonatedTenantName(): string | null {
  return sessionStorage.getItem(TENANT_KEY);
}

export function clearImpersonation(): void {
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(TENANT_KEY);
  sessionStorage.removeItem(USER_STORAGE_KEY);
}
